import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import "./index.css";
//import logTraffic from "./components/utils/logTraffic"

const root = ReactDOM.createRoot(document.getElementById("root"));

//logTraffic();

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
